export default function GeneratorLoadingCard({ status }) {
    const steps = [
        "Analyzing business inputs",
        "Building page structure",
        "Generating content and layout",
        "Preparing preview experience"
    ];

    return (
        <div className="wg-loading-shell">
            <div className="wg-loading-badge">Generating Website</div>

            <h3 className="wg-loading-title">Your AI website is being prepared.</h3>

            <p className="wg-loading-subtitle">
                We’re building the structure, shaping the content, and preparing a preview for review.
            </p>

            <div className="wg-loading-progress">
                <div className="wg-loading-progress-bar" />
            </div>

            <div className="wg-loading-status-row">
                <span className="wg-loading-status-label">Current status</span>
                <span className="wg-loading-status-value">{status || "Processing..."}</span>
            </div>

            <div className="wg-loading-steps">
                {steps.map((item, index) => (
                    <div className="wg-loading-step" key={item}>
                        <div className="wg-loading-step-dot" />
                        <div className="wg-loading-step-copy">
                            <strong>Step {index + 1}</strong>
                            <span>{item}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}